const $ = jQuery;
// Import additional libraries here
global.moment = require('moment');
require('tempusdominus-bootstrap-4');
import 'moment-timezone';

import '../../../../../../node_modules/bootstrap/dist/js/bootstrap.bundle';
import '../../../../../../node_modules/owl.carousel/dist/owl.carousel';
import '../../../../../../node_modules/lity/dist/lity';
import '../../../../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.js';

let isMobile = false;

$(window).on('load resize', function () {
    isMobile = window.matchMedia('(max-width: 776px)').matches;


    if ($(window).width() > 990) {
        $('.pricing-table__navigation').find('.tabs').find('li a').removeAttr('href');

        $('.gallery-tabs__navigation').find('.tabs').find('li a').removeAttr('href');

    } else {
        $('.pricing-table__navigation .tabs li').find('a').each(function() {
            let current = $(this);
            let link = current.attr('data-tab');
            current.attr('href', '#' + link);
        });

        $('.gallery-tabs__navigation .tabs li').find('a').each(function() {
            let current = $(this);
            let link = current.parent('li').attr('data-tab');
            current.attr('href', '#' + link);
        });
    }

});

$(document).on('lity:open', function(event, instance) {
    $(document).find('.gallery-tabs__lightbox').addClass('gallery-tabs__lightbox__video-open');
});

$(document).on('lity:remove', function(event, instance) {
    $(document).find('.gallery-tabs__lightbox').removeClass('gallery-tabs__lightbox__video-open');
});

$(document).ready(function () {

    /**
     * Mobile Menu
     */

    let header = $('header');

   $('.mobile-menu a').click(function () {
       $("#menu-main-menu").toggleClass('mobile-open');

       let $this = $(this);

       if($this.hasClass('active')) {
           $this.toggleClass('active').html('Menu');
       } else {
           $this.toggleClass('active').html('X');
       }

   });

   //Mobile navigation
    if ($(window).width() < 990) {

        if ( $('nav .menu-item').hasClass('menu-item-has-children')) {
            const html = '<div class="icon-wrapper"><span class="icon icon-chevron-right1"></span></div>';
            $('.menu-item.menu-item-has-children').append(html);
        }

        $('.menu-item-has-children > a, .menu-item-has-children .icon-wrapper').on('click', function (e) {
            if ($(this).parent('li').hasClass('active')) {
                if ($(this).hasClass('icon-wrapper')) {
                    e.preventDefault();
                    $(this).parent('li').removeClass('active');
                    $(this).siblings('.sub-menu').slideUp();
                }

            } else {
                e.preventDefault();
                $(this).parent('li').addClass('active');
                $(this).parent('li').siblings().removeClass('active');
                $(this).parent('li').find('ul').slideDown();
                $(this).parent('li').siblings().find('ul').slideUp();
            }
        });
    }

    //rest navigation styling going from mobile to desktop
    $(window).resize(function() {
        if ($(window).width() > 990) {
            if ( $('#menu-main-menu').hasClass('mobile-open')) {
                $('#menu-main-menu').removeClass('mobile-open');
                $('.mobile-menu a').html('Menu');
                $('.mobile-menu a').removeClass('active');
            }
        }
    });

    $('.attractions-slider .owl-carousel').owlCarousel({
        loop:false,
        margin:20,
        responsiveClass:true,
        responsive:{
            0: {
                items: 1,
                nav: true,
                dots: false
            },
            500:{
                items:2,
                nav:true,
                dots: false
            },
            1000:{
                items:3,
                nav:true
            },
            1200:{
                items:4,
                nav:true,
                loop:false
            }
        }
    });


    $('.attractions-links .owl-carousel').owlCarousel({
        loop:false,

        margin:20,
        responsive:{
            0: {
                items: 1,
                nav: true,
                dots: false
            },
            500:{
                items:2,
                nav:true,
                dots: false
            },
            1000:{
                items:3,
                nav:true
            },
            1200:{
                items:4,
                nav:true,
                loop:false
            }
        }
    });

    $('.events-slider .owl-carousel').owlCarousel({
        loop:true,
        margin:20,
        animateOut: 'fadeOut',
        responsiveClass:true,
        responsive:{
            0:{
                items:1,
                dots: false,
                nav:true
            },
            760:{
                items:1,
                dots: false,
                nav:true
            },
            1000:{
                items:1,
                nav:true,
                dots: true,
                loop:false
            }
        }
    });
});


$(document).ready(function () {
    if ($(window).width() < 990) {

        const header = $('h2.attractions-list__accordion-header').parent();

        $(header).on('click', function () {
            $(this).toggleClass('is-active');
            $(this).next().slideToggle();
        });

        $('h3.attractions-list__heading').on('click', function () {
            $('h3.attractions-list__heading').siblings('img').slideUp();
            $('h3.attractions-list__heading').siblings('div').slideUp();

            if (!$(this).hasClass('is-active')) {
                $('h3.attractions-list__heading').removeClass('is-active');
                $(this).addClass('is-active');
                $(this).siblings('img').slideToggle();
                $(this).siblings('div').slideToggle();
            } else {
                $(this).removeClass('is-active');
            }
        });
    }
});

$(window).resize(function() {

    if ($(window).width() > 990) {
        $('h2.attractions-list__accordion-header').css('pointer-events', 'none');

        $('.pricing-table__navigation').find('.tabs').find('li a').removeAttr('href');

        $('.gallery-tabs__navigation').find('.tabs').find('li a').removeAttr('href');

    } else {
        $('h2.attractions-list__accordion-header, h3.attractions-list__heading').css('pointer-events', 'auto');

        $('.pricing-table__navigation .tabs li').find('a').each(function() {
            let current = $(this);
            let link = current.attr('data-tab');
            current.attr('href', '#' + link);
        });

        $('.gallery-tabs__navigation .tabs li').find('a').each(function() {
            let current = $(this);
            let link = current.parent('li').attr('data-tab');
            current.attr('href', '#' + link);
        });
    }
});

$(document).ready(function () {
   $('h4.accordion-group__accordion-title').on('click', function () {
      $(this).next('.accordion-group__accordion-content').slideToggle();
      $(this).toggleClass('active');
   });
});

$(document).ready(function () {
    let hash = window.location.hash;

    if(hash === "" || hash === "#images") {
        $('.gallery-tabs ul.tabs li[data-tab="images-gallery"]').addClass('selected');
        $("#images-gallery").addClass('selected');
    } else if(hash === "#videos") {
        $('.gallery-tabs ul.tabs li[data-tab="videos-gallery"]').addClass('selected');
        $("#videos-gallery").addClass('selected');
    } else if(hash === "#webcam") {
        $('.gallery-tabs ul.tabs li[data-tab="webcam-gallery"]').addClass('selected');
        $("#webcam-gallery").addClass('selected');
    } else {
        $('.gallery-tabs ul.tabs li[data-tab="images-gallery"]').addClass('selected');
        $("#images-gallery").addClass('selected');
    }

    $('.gallery-tabs__navigation ul.tabs li').click(function(){
        let tab_id = $(this).attr('data-tab');

        $('.gallery-tabs__navigation ul.tabs li').removeClass('selected');
        $('.tab-content').removeClass('selected');

        $(this).addClass('selected');
        $("#"+tab_id).addClass('selected');
    })
});

$(document).ready(function () {
    $('.pricing-table__navigation ul.tabs li a').click(function(){
        let tab_id = $(this).attr('data-tab');

        $('.pricing-table__navigation ul.tabs li a').removeClass('selected');
        $('.tab-content').removeClass('selected');

        $(this).addClass('selected');
        $("#"+tab_id).addClass('selected');
    })
});

$(document).ready(function () {
    $('#startdatepicker').datetimepicker({
        format: 'YYYY-MM-DD',
    });
    $('#enddatepicker').datetimepicker({
        useCurrent: false,
        format: 'YYYY-MM-DD',
    });
    $("#startdatepicker").on("change.datetimepicker", function (e) {
        $('#enddatepicker').datetimepicker('minDate', e.date);
    });
    $("#enddatepicker").on("change.datetimepicker", function (e) {
        $('#startdatepicker').datetimepicker('maxDate', e.date);
    });
});

/* Mobile Menu Wordpress code
$(document).ready(function () {
    $('.mobile-nav').click(function () {
        var mobileNavEl = $(this);
        $('.navigation .navigation-container').slideToggle(300);

        $(this).toggleClass('expanded');

        if ($(this).hasClass('expanded')) {
            $('.menu-item-has-children').find('ul.sub-menu a').click(function (e) {
                e.stopImmediatePropagation();
            });
        }

        $(window).resize(function () {
            let screenWidth = $(window).width();
            if (screenWidth > 992) {
                $('.navigation .navigation-container').hide();
                mobileNavEl.removeClass('expanded');
            }
        });
    });

    $('#menu-main-menu > .menu-item-has-children > a, #menu-main-menu > .menu-item-has-children').click(function (e) {
        if ($('.mobile-nav').hasClass('expanded')) {
            let targetEl = $(this);
            if ($(this).is('a')) {
                if ($(this).parent('.menu-item-has-children').hasClass('link-active')) {
                    e.stopImmediatePropagation();
                } else if ($(this).find('ul.sub-menu').is(':visible')) {
                    e.stopImmediatePropagation();
                } else {
                    e.preventDefault();
                    $(this).find('ul.sub-menu').slideToggle(300, function () {
                        targetEl.toggleClass('link-active expanded', $(this).is(':visible'));
                    });
                }
            } else {
                $(this).find('ul.sub-menu').slideToggle(300, function () {
                    targetEl.toggleClass('link-active expanded', $(this).is(':visible'));
                });
            }
        }
    });
});
*/

/*
 * AJAX load more for gallery block
 */
$(document).ajaxStart(function () {
    $('.has-loading').addClass('show');
    $('.gallery-tabs__button').addClass('extend');
    $('.gallery-tabs__button .button').addClass('disabled');
}).ajaxStop(function () {
    $('.has-loading').removeClass('show');
    $('.gallery-tabs__button').removeClass('extend');
    $('.gallery-tabs__button .button').removeClass('disabled');
});

$('#show-more-link--video, #show-more-link--image').on('click', function () {
    let totalImageShowed = $(this).data('current-image-displayed');
    totalImageShowed = parseInt(totalImageShowed);
    const dataID = $(this).data('id');
    const wpURL=`${document.location.origin}/wp-json/wp/v2/pages/${dataID}`;

    /* Check whether to get image block or video block details */
    const targetElement = this.className;

    let blockKey,
        blockElementKey;

    if (targetElement.includes('video')) {
        blockKey = 'gallery_videos';
    } else {
        blockKey = 'gallery_images';
    }

    $.ajax({
        type: 'GET',
        url: wpURL,
        context: $(this),
        success: function ( data ) {

            const getBlocks = data.blocks;
            let numberOfImages;

            let gallery = getBlocks.filter(x => x.blockName === 'acf/gallery');
            gallery = gallery[0].attrs.data;
            Object.keys(gallery).forEach(function(key) {
                if (key === blockKey) {
                    numberOfImages = gallery[key];
                }
            });

            getImageURL(gallery, totalImageShowed, numberOfImages, targetElement, $(this));

        },
        error: function (request, textStatus, errorThrown) {
            //FailSafe for WP API Failing
        }
    });

    function getImageURL($img, $totalImageShowed, $numberOfImages, $targetElement, $button) {
        let galleryImage,
            galleryImageSource,
            imageContent,
            counter = 1,
            nextImages;


        const screenWidth = window.matchMedia("(max-width: 768px)");

            if (screenWidth.matches) {
                nextImages = 2;
            } else {
                nextImages = 3;
            }

        for (var i = $totalImageShowed; i < $numberOfImages && counter <=nextImages; i++) {

            let blockVideoURL;

            if (targetElement.includes('video')) {
                blockElementKey = `gallery_videos_${i}_gallery_videos_image`;
                blockVideoURL = `gallery_videos_${i}_gallery_videos_video`;
            } else {
                blockElementKey = `gallery_images_${i}_gallery_images_image`;
            }

            let videoURL = '';

            Object.keys($img).forEach(function(key) {
                if (key === blockVideoURL) {
                    videoURL = $img[key];
                    console.log(videoURL);
                }
            });

            Object.keys($img).forEach(function(key) {
                if (key === blockElementKey) {

                    const imageURL=`${document.location.origin}/wp-json/wp/v2/media/${$img[key]}`;

                    $.ajax({
                        type: 'GET',
                        url: imageURL,
                        context: $(this),
                        success: function ( imageData ) {
                            galleryImage = imageData.media_details.sizes.gallery_thumbnail.source_url;
                            galleryImageSource = imageData.source_url;

                            imageContent = getContent(galleryImage, galleryImageSource,  $totalImageShowed, $numberOfImages, $targetElement, videoURL, $button, nextImages);
                        }
                    });
                }
            });

            counter++;
        }
    }

});

$(document).ready(function () {
    $("a.fancybox").fancybox({
        arrows : true
    });
})

function getContent($galleryImageLink, $galleryImageSource, $totalImageShowed, $numberOfImages, $targetElement, $videoURL, $button, $nextImages) {

    let imageArray = [];

    imageArray.push($galleryImageLink);

    let contentHTML = '';
    let link;

    Object.values(imageArray).forEach(function(value) {

        if ($videoURL.length > 1) {
            link = $videoURL;
        } else {
            link = $galleryImageSource;
        }

        contentHTML = contentHTML + `
            <div class="gallery-tabs__lightbox">
                <a href="${link}" data-fancybox="gallery">
                    <img src="${value}" alt="" />
                </a>
            </div>
        `;
    });

    if ( contentHTML.length > 0 ) {

        if ($targetElement.includes('video')) {
            $('#load-more__button--video').before(contentHTML);
        } else {
            $('#load-more__button--image').before(contentHTML);
        }
    }

    $totalImageShowed = $totalImageShowed + $nextImages;

    $button.attr('data-current-image-displayed', $totalImageShowed);
    $button.data('current-image-displayed', $totalImageShowed);

    if ( ($numberOfImages - $totalImageShowed) <= 0) {
        if ($targetElement.includes('video')) {
            $('#show-more-link--video').remove();
        } else {
            $('#show-more-link--image').remove();
        }

    }
}

// Newsletter Submit Button
// Adds the email address from the subscribe field to the form field

$(document).ready(function () {
   $('a.submit-btn').click(function () {
       $('#email').val($('#newsletter-email').val());
   })
});
